import {customAxiosBE} from "../config";

export async function getTurnusListAPI({status, from, to} = {}) {
    const parts = [];
    if (status !== undefined && status !== null && status !== "") {
        parts.push(`status=${status}`);
    }
    if (from && to) {
        parts.push(`from=${from}`, `to=${to}`);
    }
    return customAxiosBE.get(`/turnus${parts.length ? `?${parts.join("&")}` : ""}`);
}

export async function getTurnusByIdAPI(id) {
    return customAxiosBE.get(`/turnus/${id}`);
}

export async function insertTurnusAPI(payload) {
    return customAxiosBE.post(`/turnus`, payload);
}

export async function updateTurnusAPI(id, payload) {
    return customAxiosBE.put(`/turnus/${id}`, payload);
}

export async function copyTurnusAPI(id) {
    return customAxiosBE.post(`/turnus/${id}/copy`);
}

export async function deleteTurnusAPI(id) {
    return customAxiosBE.delete(`/turnus/${id}`);
}

export async function autogenerateTurnusAPI(tripIds) {
    return customAxiosBE.post(`/turnus/autogenerate`, tripIds);
}
